import { MAX_SELECTED_LENGTH } from 'components/StoreSelector/hooks/useStoreSelector';
import { useCallback } from 'react';
import { atom, useAtom } from 'jotai';
import { SearchStoreListScene, StoreInfo, searchStoreList } from 'services/api/store';

export const followedStoreListMapState = atom<Partial<Record<SearchStoreListScene, StoreInfo[]>>>(
  {},
);

export function useGetFollowedStoreList() {
  const [map, setMap] = useAtom(followedStoreListMapState);

  return useCallback(
    (scene: SearchStoreListScene) => {
      const { [scene]: current } = map;

      if (current) {
        return Promise.resolve(current);
      }

      return searchStoreList({
        follower: '1',
        cursor: 0,
        page_size: MAX_SELECTED_LENGTH,
      }).then((res) => {
        const list = res.data.data.data;

        setMap((pre) => ({
          ...pre,
          [scene]: list,
        }));

        return list;
      });
    },
    [map, setMap],
  );
}
